export default __webpack_public_path__ + "images/vr_glass.jpg";